'use client';

// ── Payout Cap · payout calculation example ──────────────────────────────────
// Figma "Moldura · Exemplo · cálculo": desktop 12071:60023 (792×325), mobile
// 12471:10894 (366×325) — same layout at both widths. Three key/value rows,
// the highlighted "Your payout maximum" row (its green bleeds 12px past the
// padding) and the buffer remainder. Sizes are Figma px / 8 in rem.

import { ExampleLabel, FigureFrame } from '../primitives';

const TEXT = 'mb-0 whitespace-nowrap text-[2rem] leading-[3rem]';

function Row({ label, value, dataUi }: { label: string; value: string; dataUi: string }) {
  return (
    <div
      data-ui={dataUi}
      className="flex w-full items-center justify-between gap-[2rem] border-b border-black/[0.06] py-[1.25rem]"
    >
      <p className={`${TEXT} font-normal text-black/[0.64]`}>{label}</p>
      <p className={`${TEXT} font-medium text-black`}>{value}</p>
    </div>
  );
}

export default function PayoutCapCalculation() {
  return (
    <FigureFrame data-ui="figure.payoutCapCalculation" className="gap-[0.5rem] font-geist">
      <div className="w-full pb-[1rem]">
        <ExampleLabel>EXAMPLE · PAYOUT CALCULATION</ExampleLabel>
      </div>

      <Row dataUi="figure.payoutCapCalculation.row-1" label="Profit at the time of the request" value="$5,000" />
      <Row dataUi="figure.payoutCapCalculation.row-2" label="50% of the profit" value="$2,500" />
      <Row dataUi="figure.payoutCapCalculation.row-3" label="Payout Cap of this account" value="$2,000" />

      {/* Seu máximo — the green highlight bleeds 12px past the frame padding */}
      <div
        data-ui="figure.payoutCapCalculation.max"
        className="relative flex w-full items-center justify-between gap-[2rem] py-[1.5rem]"
      >
        <div className="absolute -left-[1.5rem] -right-[1.5rem] inset-y-0 rounded-[0.25rem] bg-[#e2f3ef]" />
        <p className={`${TEXT} relative font-medium text-[#196551]`}>Your payout maximum</p>
        <p className="relative mb-0 whitespace-nowrap text-[3rem] font-medium leading-[4rem] text-[#228e71]">$2,000</p>
      </div>

      <div
        data-ui="figure.payoutCapCalculation.row-buffer"
        className="flex w-full items-center justify-between gap-[2rem] pt-[1.25rem]"
      >
        <p className={`${TEXT} font-normal text-black/[0.64]`}>
          Stays in the account as{' '}
          <a href="?rule=buffer" className="text-[#228e71] underline [text-underline-position:from-font]">
            Buffer
          </a>
        </p>
        <p className={`${TEXT} font-medium text-black`}>$3,000</p>
      </div>
    </FigureFrame>
  );
}
